import { Component } from 'react';
import { SharedSnackbar } from './sharedSnackbar';
import { SnackbarContext, SnackbarInputType, SnackbarMessageType } from './snackbarContext';

interface Props {
  children: React.ReactNode;
}

interface State {
  isOpen: boolean;
  message: string;
  type: SnackbarMessageType;
}

export class SnackbarContextProvider extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
      message: '',
      type: SnackbarMessageType.INFO,
    };

    this.info = this.info.bind(this);
    this.success = this.success.bind(this);
    this.warn = this.warn.bind(this);
    this.error = this.error.bind(this);

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  public render() {
    const { children } = this.props;
    const { isOpen, message, type } = this.state;

    return (
      <SnackbarContext.Provider
        value={{
          open: this.open,
          info: this.info,
          success: this.success,
          warn: this.warn,
          error: this.error,
          close: this.close,
          isOpen,
          message,
          type,
        }}
      >
        <SharedSnackbar />

        {children}
      </SnackbarContext.Provider>
    );
  }

  private open(input: SnackbarInputType, type?: SnackbarMessageType) {
    if (!type) {
      type = input instanceof Error ? SnackbarMessageType.ERROR : SnackbarMessageType.INFO;
    }

    const message = input instanceof Error ? input.message : input;

    this.setState({ isOpen: true, message, type });
  }

  private info(input: SnackbarInputType) {
    this.open(input, SnackbarMessageType.INFO);
  }

  private success(input: SnackbarInputType) {
    this.open(input, SnackbarMessageType.SUCCESS);
  }

  private warn(input: SnackbarInputType) {
    this.open(input, SnackbarMessageType.WARN);
  }

  private error(input: SnackbarInputType) {
    this.open(input, SnackbarMessageType.ERROR);
  }

  private close() {
    this.setState({ isOpen: false });
  }
}
